import { Component, OnDestroy, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '@environment';

// Hosts a recaptcha control and provides access to its response.
@Component({
  selector: 'sp-captcha',
  template: `<re-captcha (resolved)="captchaResolved($event)" siteKey="{{siteKey}}"></re-captcha>`
})
export class CaptchaComponent implements OnDestroy {
  siteKey: string = environment.captchaSiteKey;

  // Contains the user's current response.  If null, either no response has been accepted or the
  // response has timed out.
  @Output()
  public Response: BehaviorSubject<string>;

  constructor() {
    this.Response = new BehaviorSubject<string>(null);
  }

  ngOnDestroy() {
    this.Response.complete();
  }

  // Handles the "resolved" event for the recaptcha component.  If the captcha expires this will be
  // called with a "null" reponse value.
  captchaResolved(response: string) {
    this.Response.next(response);
  }
}